import { defineAsyncComponent } from 'vue'
import editPage from './src/views/edit-page/index.vue'

// 大屏编辑页
export const StandardPageEditPage = editPage
// 属性区
export * from './src/components/attr-comp/index'
